import React from 'react';
import {Section} from '../section/Section';
import css from './SetupVRChat.module.scss';
import {Button} from 'react-bootstrap/lib/InputGroup';
import {ButtonV2} from '../../../system/ButtonV2/ButtonV2';

export const SetupVRChatSection: React.FC<{}> = () => {
  return (
    <Section
      title="Add MIDI settings in VR Chat"
      number={4}
      type="setup-vr-chat"
    >
      <div className={css.container}>
        <div>
          <div className={css.title}>
            Go to VRChat → Launch Options and paste the code from below
          </div>
          <div className={css.subtitle}>
            Open VRChat from your Steam or Oculus PC and add a line to VRChat
            Launch Options
          </div>
        </div>
        <div className={css.code_container}>
          <h4>--midi=pulsoidmidi</h4>
          <div>
            <ButtonV2
              copy={{
                textToCopy: '--midi=pulsoidmidi',
                notificationText: 'Copied!',
              }}
            >
              Copy Settings
            </ButtonV2>
          </div>
        </div>

        <div className={css.video_container}>
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/Z7E-kAe5kBY?si=bmoEUG7vqx4nKLys"
            title="YouTube video player"
            // @ts-ignore
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </Section>
  );
};
